import { reactive, readonly } from 'vue';
import { warehousesApi } from '@/services/resources';

// Kho đang làm việc. Từ revision `015` xưởng chỉ có **một** kho, nên đây không
// còn là một lựa chọn — công tắc ở topbar đã đi cùng màn Chuyển kho, và
// `load()` tự chọn kho duy nhất API trả về.
//
// Store vẫn còn vì `warehouse_id` vẫn là thứ mọi màn hình gửi lên: phạm vi theo
// kho (`user_warehouse_assignments`, thiết kế §8) không đổi, và ngày xưởng mở
// kho thứ hai thì chỗ để dựng lại công tắc là đây chứ không phải mười màn hình.
//
// Không còn `localStorage`: nó tồn tại để nhớ lựa chọn giữa hai lần mở trình
// duyệt, và một lựa chọn giữa đúng một phương án thì không có gì để nhớ — giữ
// lại chỉ là một id cũ có cơ hội chỏi với danh sách thật.
const state = reactive({ list: [], selectedId: null, loading: false, loaded: false });

export const warehouseStore = {
  state: readonly(state),
  get selected() { return state.list.find((warehouse) => warehouse.id === state.selectedId) || null; },
  async load(force = false) {
    if (state.loading || (state.loaded && !force)) return state.list;
    state.loading = true;
    try {
      const response = await warehousesApi.list({ page: 1, page_size: 100, is_active: true, sort: 'code' });
      state.list = response.items || response || [];
      state.loaded = true;
      if (!state.list.some((warehouse) => warehouse.id === state.selectedId)) state.selectedId = state.list[0]?.id || null;
    } catch (_) { state.list = []; }
    finally { state.loading = false; }
    return state.list;
  },
  reset() { state.loaded = false; state.list = []; state.selectedId = null; },
};
